import PaymentSummary from '../../../../../components/buybox/payment/payment.desktop';
import payment from './payment';

const configuredPaymentSummary = payment(PaymentSummary);
export default configuredPaymentSummary;
